<template>
  
    <s-crud 
    title="Variedades"
    :config="configVariedades"
    @save="save($event)"
    edit
    add
    remove   
    :filter="filter"
    search-input  
    ref="crud"
    >
    
   <template scope="props">
        <!--  <v-container class="pb-0"> -->
          <v-row justify="center" style="margin:auto">

              <v-col cols="9" class="s-col-form">
                <s-text v-model="props.item.VrtDescription" label="Descripción" > </s-text> 
              </v-col>
                <v-col cols="3" class="s-col-form">
                  <s-text v-model="props.item.VrtHelper" label="Helper" > </s-text> 
                </v-col> 
                <v-col cols="12" class="s-col-form" sm="4" md="8" lg="4">
              <s-select-definition v-model="props.item.VrtStatus" :def="1219" label="Estado"></s-select-definition>
            </v-col>                            
               </v-row>    
          </template>
     <template v-slot:Estado="{ row }">
        <v-chip style="margin:0px" x-small :color="row.Estado == 'Inactivo' ? 'error' : 'success'">
            {{ row.Estado}}
        </v-chip>
      </template> 
     </s-crud>

</template>


<script>
import _sVarietyService from "@/services/Technicalassistance/VarietyService";


export default {
  name: "RequirementServiceVariety",
  components: {  },
  props: {
    DedID:{ type: Number, default: 0 },
       parentID: { type: Number, default: 0 },
    addNoFunction: { type: Boolean, default: false },
  },

  data() {
    return {
      dialogEdit: false,   
     };     
  },

  computed: {
   
    configVariedades() {
      return {
        model: {
          //RETORNAR PROPIEDAD COMPUTADA
          VrtID: "ID",
          VrtDescription: "string",         
          DedDescription: "string", 
           Estado: "string",
              VrtStatus: "status",
          //
          }, 
        service: _sVarietyService,
        headers:  this.$fun.getSecurity().IsLevelAdmin  
          ? [
              //Vista de tabla para admin
              { text: "ID", value: "VrtID", sortable: false },
              { text: "Descripción", value: "VrtDescription", sortable: false },
              { text: "Cultivo", value: "DedDescription", sortable: false }, 
              { text: "Helper", value: "VrtHelper", sortable: false },
              { text: "Estado", value: "Estado", sortable: false },           
            ]
          : [ 
                // CABECERA EN CASO NO SE LOGEE COMO ADMIN            
            { text: "ID", value: "VrtID", sortable: false },
            { text: "Descripción", value: "VrtDescription", sortable: false },
            { text: "Cultivo", value: "DedDescription", sortable: false },   

            { text: "Helper", value: "VrtHelper", sortable: false },
            { text: "Estado", value: "Estado", sortable: false },            
            ],
      };
    }, 
    
    isAdmin() {
      this.$fun.getSecurity().IsLevelAdmin;
         },  
  },
  

  methods: {

 Initialize() {
   //DedID: this.DedID -- base de datos: campo actual
       this.filter = {DedID: this.DedID};
     
    },


    edit(item) {
      this.dialogEdit = true;
    
    },

    rowSelected(rows) {
      if (rows.length > 0) {
        this.$emit("rowSelected", rows);       
      }
    },

    save(item) {
     //console.log(item);
     item.VrtHelper = item.VrtHelper.trim();
     item.DedID=this.DedID
      
      if (this.$fun.getSecurity().IsLevelAdmin) {   
        //VALIDACIONES
        if (item.VrtDescription.length == 0) {
          this.$fun.alert("Registre la descripción de la variedad", "warning");
          return;
        }
        if (item.DedID == 0) {
          this.$fun.alert("Seleccione el Cultivo", "warning");
          return; 
        }
        item.SecStatus=1;
        item.save();
      }
       else {

        if (item.VrtDescription.length == 0) {
          this.$fun.alert("Registre la descripción de la variedad", "warning");
          return;
        }
        if (item.DedID == 0) {
          this.$fun.alert("Seleccione el Cultivo", "warning");
          return; 
        }
        item.SecStatus=1;
        item.save();

      } 
      
      
    },    
  },
  watch: {
    // este DedID es el que esta en variety, vista general en DedID  ="dedID"
    DedID(){   
        
      this.Initialize();    
      },
  },
   created() {
    this.filter = { DedID: 0 };
  },
};
</script>
